import React from 'react';
import { Link } from 'react-router-dom';
import * as Dialog from '@radix-ui/react-dialog';
import { ShieldAlert } from 'lucide-react';

const AgeGate = ({ onConfirm }) => {
  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="fixed inset-0 z-50 flex items-center justify-center"
          style={{ background: 'rgba(3,4,5,0.97)', backdropFilter: 'blur(12px)' }}
        >
          <Dialog.Content
            data-testid="age-gate-modal"
            aria-describedby={undefined}
            className="relative flex flex-col items-center text-center max-w-md w-full mx-4 p-10"
            style={{
              border: '1px solid rgba(255,0,60,0.25)',
              background: 'rgba(8,11,15,0.98)',
              boxShadow: '0 0 40px rgba(255,0,60,0.08), inset 0 0 40px rgba(0,0,0,0.3)',
            }}
          >
            <Dialog.Title className="sr-only">Age Verification Required</Dialog.Title>
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-[#FF003C]/50" />
            <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-[#FF003C]/50" />
            <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-[#FF003C]/50" />
            <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-[#FF003C]/50" />

            <div className="mb-6 flex items-center justify-center w-14 h-14 border border-[#FF003C]/30"
              style={{ boxShadow: '0 0 20px rgba(255,0,60,0.12)' }}>
              <ShieldAlert size={28} className="text-[#FF003C]" />
            </div>

            <div className="text-[11px] uppercase tracking-[0.4em] text-[#FF003C]/70 mb-2 font-mono">
              Access Control
            </div>
            <h1 className="text-4xl font-light tracking-[0.1em] text-white mb-2 font-mono">18+</h1>
            <p className="text-[11px] uppercase tracking-[0.25em] text-gray-500 mb-6">
              Age Verification Required
            </p>

            <div className="w-full h-px bg-gradient-to-r from-transparent via-[#FF003C]/25 to-transparent mb-6" />

            <p className="text-sm text-gray-400 leading-relaxed mb-2">
              This application contains mature content intended for adults only.
            </p>
            <p className="text-xs text-gray-600 leading-relaxed mb-8">
              By entering, you confirm you are at least <strong className="text-gray-500">18 years of age</strong> and consent
              to viewing adult-oriented educational and design material.
            </p>

            <div className="w-full p-3 mb-8 border border-[#00F0FF]/10 bg-[#00F0FF]/3">
              <p className="text-[10px] text-gray-600 uppercase tracking-widest leading-relaxed">
                This tool is for educational, design, artistic &amp; 3D printing purposes only.
              </p>
            </div>

            <Link
              to="/about"
              className="text-[9px] uppercase tracking-[0.25em] text-gray-600 hover:text-gray-400 transition-colors mb-6 font-mono"
            >
              About this project →
            </Link>

            <div className="flex gap-3 w-full">
              <button
                data-testid="age-gate-deny"
                onClick={() => window.location.href = 'https://www.google.com/'}
                className="flex-1 py-3 text-[10px] uppercase tracking-[0.2em] border border-gray-700 text-gray-500 hover:border-gray-600 hover:text-gray-400 transition-all duration-150 font-mono"
              >
                Exit
              </button>
              <button
                data-testid="age-gate-confirm"
                onClick={onConfirm}
                className="flex-1 py-3 text-[10px] uppercase tracking-[0.2em] border font-mono transition-all duration-150 text-white"
                style={{
                  borderColor: 'rgba(255,0,60,0.5)',
                  background: 'rgba(255,0,60,0.08)',
                  boxShadow: '0 0 15px rgba(255,0,60,0.08)',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,0,60,0.15)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,0,60,0.08)'; }}
              >
                I am 18+ — Enter
              </button>
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default AgeGate;
